export { default } from "./TransactionDetail";

